import {Pipe, PipeTransform} from '@angular/core';
import {Role} from '../classes/auth/role.class';
import {Functionality} from '../classes/auth/functionality';

@Pipe({
    name: 'roleHasFunctionality',
})
export class RoleHasFunctionalityPipe implements PipeTransform {

    transform(role: Role, functionality: Functionality, ...args: unknown[]): boolean {
        return !!role.functionalities.find(f => f.key === functionality.key);
    }

}
